import React from 'react';
import { useLabs } from '../../hooks/useLabs';
import { LabsLoader, LabsError } from './LabsLoader';
import './Labs.css';

export const LabsHub = () => {
  const { routes, userProgress, loading, error, setSelectedRoute, fetchRoutes } = useLabs();

  if (loading) {
    return <LabsLoader message="Cargando laboratorios de pentesting..." />;
  }

  if (error) {
    return (
      <LabsError 
        error={error} 
        onRetry={() => {
          console.log('🔄 Reintentando cargar labs...');
          fetchRoutes();
        }}
      />
    );
  }

  if (!routes || routes.length === 0) {
    return (
      <LabsError 
        error="No hay laboratorios disponibles en este momento" 
        onRetry={() => {
          console.log('🔄 Reintentando cargar labs...');
          fetchRoutes();
        }}
      />
    );
  }

  const getRouteProgress = (routeId) => {
    const progress = userProgress[routeId];
    if (!progress) return 0;
    const completed = progress.niveles?.filter(n => n.completado).length || 0;
    const total = progress.niveles?.length || 1;
    return (completed / total) * 100;
  };

  return (
    <div className="labs-hub">
      <div className="labs-header">
        <h1>Laboratorios de Pentesting</h1>
        <p>Aprende seguridad ofensiva con escenarios reales</p>
      </div>

      <div className="labs-grid">
        {routes.map(route => (
          <div key={route.id} className="lab-card">
            <div className="lab-card-header">
              <div className="lab-icon">{route.icono}</div>
              <div className="lab-difficulty" data-difficulty={route.dificultad}>
                {route.dificultad}
              </div>
            </div>

            <div className="lab-card-body">
              <h3>{route.titulo}</h3>
              <p>{route.descripcion}</p>

              <div className="lab-meta">
                <span className="lab-levels">{route.niveles?.length || 0} niveles</span>
                <span className="lab-duration">⏱️ {route.duracion_estimada_horas}h</span>
              </div>

              <div className="progress-wrapper">
                <div className="progress-bar">
                  <div 
                    className="progress-fill"
                    style={{ width: `${getRouteProgress(route.id)}%` }}
                  ></div>
                </div>
                <span className="progress-text">
                  {Math.round(getRouteProgress(route.id))}%
                </span>
              </div>
            </div>

            <div className="lab-card-footer">
              <button 
                className="btn-primary"
                onClick={() => setSelectedRoute(route.id)}
              >
                {getRouteProgress(route.id) > 0 ? 'Continuar' : 'Comenzar'}
              </button>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
};
